"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var MapSkeletonContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-skeleton-header {\n    width: 100% !important;\n    height: inherit;\n    .ant-skeleton-avatar-lg {\n      width: 100% !important;\n      height: inherit;\n    }\n  }\n"], ["\n  .ant-skeleton-header {\n    width: 100% !important;\n    height: inherit;\n    .ant-skeleton-avatar-lg {\n      width: 100% !important;\n      height: inherit;\n    }\n  }\n"])));
exports.default = MapSkeletonContainer;
var templateObject_1;
